import { createAsyncThunk } from '@reduxjs/toolkit';

import { RegistrationService } from 'api';

import { RegisterPayloadProps } from 'models/api';

import { asyncPayloadCreator } from 'utils';

export const register = createAsyncThunk(
	'registration/register',
	(credentials: RegisterPayloadProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, RegistrationService.register),
);
